import translationReducer from './translationSlice';
import clientTranslationReducer from './mainAccount/ClientTranslationSlice';
import interpreterTranslationReducer from './interpreter/interpreterTranslationSlice';
import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';
import cityReducer from './citySlice';
import languageReducer from './languageSlice';

import stateReducer from './stateSlice';
import interpreterReducer from './interpreterSlice';
import vendorReducer from './vendorSlice';
import adminReducer from './adminSlice';
import profileReducer from './profileSlice';
import availibilityReducer from './availibilitySlice';
import scheduleReducer from './scheduleSlice';

import typesReducer from './typeSlice';
import accountReducer from './accountSlice';

import subUserReducer from './subUserSlice';

import appointmentReducer from './appointmentSlice'; // Assuming you have a slice named appointmentSlice
import dashboardReducer from './dashboardSlice'; // Assuming you have a slice named appointmentSlice
import permissionReducer from './permissionGroupSlice'; // Assuming you have a slice named appointmentSlice
import appReducer from './appSlice'; // Assuming you have a slice named appointment

import actionButtonReducer from './actionButtonSlice'; // Assuming you have a slice named appointment
import inviteInterpreterReducer from './inviteInterpreterSlice'; // Assuming you have a slice named appointment
import inviteVendorReducer from './inviteVendorSlice';
import interviewInvitesReducer from './interviewInviteSlice'; // Assuming you have a slice named appointment
import invoiceReducer from './invoiceSlice'; // Assuming you have a slice named appointment
import facilityReducer from './facilitiesSlice'; // Assuming you have a slice named facilitySlice
import departmentReducer from './departmentsSlice'; // Assuming you have a slice named facilitySlice

import mainAccountDashboardReducer from './mainAccount/dashboardSlice'; 
import mainSubAccountReducer from './mainAccount/subAccountSlice';      
import mainAccountInvoiceReducer from './mainAccount/mainAccountInvoiceSlice';      
import mainAccountProfileRefucer from './mainAccount/mainAccountProfileSlice';      
import mainAccountAppointmentReducer from './mainAccount/mainAccountAppointmentSlice'; 
import paymentReducer from './paymentSlice';

import interpreterDashboardReducer from './interpreter/dashboardSlice';
import interpreterPaymentReducer from './interpreter/paymentSlice';      
import interpreterProfileRefucer from './interpreter/profileSlice';      
import interpreterAppointmentReducer from './interpreter/appointmentSlice'; 

import vendorDashboardReducer from './vendor/dashboardSlice';
import vendorPaymentReducer from './vendor/paymentSlice';      
import vendorProfileRefucer from './vendor/profileSlice';      
import vendorAppointmentReducer from './vendor/appointmentSlice'; 
import vendorInterpreterReducer from './vendor/interpreterSlice'; 
import iframeReducer  from "./iframeSlice";
import interpreterIframeReducer  from "./interpreter/interpreterIframeSlice";
import requesterIframeReducer  from "./requesterIframeUrlSlice";


import inviteTranslatorReducer from './inviteTranslatorSlice'; // Assuming you have a slice named appointment
import inviteInterpreterTranslatorReducer from './interpreter/inviteInterpreterTranslatorsSlice';
import clientReducer from "./ClientNameSlice"; 
import translatorReducer from "./TranslatorNameSlice"; 

export default combineReducers({
    user: userReducer,
    profile: profileReducer,
    hospital: hospitalReducer,
    city: cityReducer,
    language: languageReducer,
    facilities: facilityReducer,
    departments: departmentReducer,
    state: stateReducer,
    vendor: vendorReducer,
    admin: adminReducer,
    availibility: availibilityReducer, // Assuming you have a slice named availibilitySlice
    schedule: scheduleReducer, // Assuming you have a slice named,
    iframe: iframeReducer,
    interpreterIframe: interpreterIframeReducer,
    requesterIframe: requesterIframeReducer,
    payment: paymentReducer,

    
    // crm slices
    types: typesReducer,
    accounts: accountReducer,

    subUser: subUserReducer,
    interpreter: interpreterReducer,

    appointments: appointmentReducer,
    dashboard : dashboardReducer,
    permission : permissionReducer,
    appStates: appReducer,
    actionButton: actionButtonReducer,

    inviteInterpreters: inviteInterpreterReducer,
    inviteVendors: inviteVendorReducer,
    invoices: invoiceReducer,
    interviewInvites: interviewInvitesReducer,

    // main account access 
    mainAccountDashboard : mainAccountDashboardReducer,
    mainSubAccounts: mainSubAccountReducer,
    mainAccountInvoice: mainAccountInvoiceReducer,
    mainAccountProfile: mainAccountProfileRefucer,
    mainAccountAppointments: mainAccountAppointmentReducer,

    // interpreter access
    interpreterDashboard : interpreterDashboardReducer,
    payment: interpreterPaymentReducer,
    interpreterProfile: interpreterProfileRefucer,
    interpreterAppointments: interpreterAppointmentReducer,

    // interpreter access
    vendorDashboard : vendorDashboardReducer,
    payment: vendorPaymentReducer,
    vendorProfile: vendorProfileRefucer,
    vendorAppointments: vendorAppointmentReducer,
    vendorInterpreter: vendorInterpreterReducer,



    translation: translationReducer,
    clientTranslation: clientTranslationReducer,
    interpreterTranslation: interpreterTranslationReducer,
    inviteTranslators: inviteTranslatorReducer,
    inviteInterpreterTranslators: inviteInterpreterTranslatorReducer,
    clients: clientReducer,
    translators: translatorReducer,
});
